import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const PrinterIcon = ({
  color = "currentColor",
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 20),
    viewBox: "0 0 20 20",
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "M15 15.7h2.9a1.4 1.4 0 0 0 1.4-1.4V7.9a1.4 1.4 0 0 0-1.4-1.5H2A1.4 1.4 0 0 0 .7 8v6.4a1.4 1.4 0 0 0 1.4 1.4H5"
    }), /*#__PURE__*/jsx("path", {
      d: "M5 13.6v5a.7.7 0 0 0 .7.7h8.6a.7.7 0 0 0 .7-.7v-5H5ZM15 6.4v-5a.7.7 0 0 0-.7-.7H5.7a.7.7 0 0 0-.7.7v5M15.7 10h-1.4"
    })]
  });
};

export { PrinterIcon };
//# sourceMappingURL=printer.js.map
